﻿import {IProgress} from "@2d-front-monorepo/core";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";
import IPermitsHttpClient from "../http/IPermitsHttpClient";
import {CreateReservationArguments} from "../types/arguments/CreateReservationArguments";
import {CreateReservationCommand} from "../types/CreateReservationCommand";
import {CreateReservationResult} from "../types/CreateReservationResult";
import countAttachments from "./countAttachments";
import {ProgressReporter} from "./progressReporter";
import reportProgress from "./reportProgress";
import {toFormAttachments} from "./toFormAttachments";
import {updatePaymentMethod} from "./updatePaymentMethod";

export async function createReservationFromCommand(httpClient: IPermitsHttpClient, state: CreateReservationCommand, reporter?: ProgressReporter | undefined): Promise<CreateReservationResult> {
	const progress: IProgress = {current: 0, total: countAttachments(state.reservation.attachments), label: ""};
	const formReservation = state.reservation.arguments;
	const reservationAttachments = await toFormAttachments(httpClient, state.reservation.attachments, progress, reporter);

	const args: CreateReservationArguments = {
		tariffId: state.tariffId,
		category: state.category,
		parkingType: state.parkingType,
		reservation: {
			type: formReservation.type,
			purpose: formReservation.purpose,
			startDate: formReservation.startDate,
			endDate: formReservation.endDate,
			customData: formReservation.customData,
			blocks: formReservation.blocks,
			meters: formReservation.meters,
			paymentMethod: updatePaymentMethod(formReservation.paymentMethod, reservationAttachments),
			attachments: reservationAttachments
		}
	}

	progress.label = PermitTranslations.create_permit__create_reservation;
	reportProgress(progress, reporter);
	return httpClient.reservations.create(args);
}
